const purchase = {
  title: "HitPaw Online Pro",
  subTitle: "اختر الخطة المناسبة بسعر بسيط وواضح",
  monthlyUppercase: "شهريًا",
  montly: "سنويًا",
  free: "مجانًا",
  yearlyUppercase: "سنويًا",
  yearly: "شهريًا",
  inService: "في الخدمة",
  buyBtn: "اشتر الآن",
  freeTips1: "يدعم حجم الملف بحد أقصى 20MB",
  freeTips2: "6 ملفات في اليوم",
  freeTips3: "سرعة المعالجة العادية",
  freeTips4: "سرعة التحميل العادية",
  freeTips5: "أزل خلفية صورة واحدة في اليوم",
  freeTips6: "الوصول إلى جميع الأدوات المجانية",
  vipTips1: "حجم الملف غير محدود",
  vipTips2: "عدد ملفات غير محدود في اليوم",
  vipTips3: "سرعة التحميل أكبر ×10",
  vipTips4: "سرعة المعالجة أكبر × 10",
  vipTips5: "غير محدود",
  vipTips6: "إزالة خلفيات الصور في اليوم بلا حدود",
  vipTips7: "الوصول إلى جميع المزايا المجانية والمدفوعة",
  vipTips8: "التجديد تلقائيًا والإلغاء في أي وقت.",
  vipTips9: "لا يوجد حد لحجم الفيديو وكميته",
  vipTips10: "إزالة الخلفيات من الصور بلا حدود",
  vipTips11: "معالجة وتنزيل الفيديو بسرعة أكبر 10X",
  vipTips12: "الوصول إلى جميع المزايا المجانية والمدفوعة",
  acceptTitle: "نحن نقبل",
  modalTitle: "ترقية إلى الحساب المميز للوصول إلى جميع المزايا المدفوعة",
  total: "الإجمالي",
  enterCode: "أدخل الرمز",
  SignUpToPurchaseBtn: "أنشئ حسابًا للشراء",
  purchaseBtn: "اذهب إلى الشراء",
  saveTips: "وفر حتى {{num}}%",
  discount: "خصم",
  purchaseTips: "التجديد تلقائيًا والإلغاء في أي وقت.",
  tips: "نصائح:",
  promoCodeInvalidTips: "رمزك الترويجي غير صالح",
};

export default purchase;
